import {Card, Form, FormButton, FormField, FormSubmitHandler} from 'platform/components';
import {Grid, Right, Space, Text} from 'platform/foundation';
import {object} from 'yup';

import i18n from '@dms/i18n';

import {Nullish, yupString} from 'shared/web';

type PlatformAuthenticationFormMobileDeData = {
  username: string;
  password: string;
  sellerId: string;
};

export type PlatformAuthenticationFormMobileDeProps = {
  defaultValues: PlatformAuthenticationFormMobileDeData | Nullish;
  onSubmit: FormSubmitHandler<PlatformAuthenticationFormMobileDeData>;
};

export function PlatformAuthenticationFormMobileDe(props: PlatformAuthenticationFormMobileDeProps) {
  return (
    <Card title={i18n.t('general.labels.authentication')}>
      <Text size="small" color="secondary">
        {i18n.t('page.settings.labels.authenticationDescription')}
      </Text>
      <Space vertical={4} />
      <Form<PlatformAuthenticationFormMobileDeData>
        defaultValues={props.defaultValues}
        schema={schema}
        onSubmit={props.onSubmit}
        shouldWatchForUnsavedChanges
      >
        {(control) => (
          <>
            <Grid columns={2}>
              <FormField
                control={control}
                name="username"
                type="text"
                label={i18n.t('page.advertisement.labels.username')}
              />
              <FormField
                control={control}
                name="password"
                type="password"
                label={i18n.t('general.labels.password')}
              />
            </Grid>
            <Space vertical={4} />
            <Grid columns={2}>
              <FormField
                control={control}
                name="sellerId"
                type="text"
                label={i18n.t('page.settings.labels.dealerId')}
              />
            </Grid>
            <Space vertical={4} />
            <Right>
              <FormButton control={control} type="submit" title={i18n.t('general.actions.save')} />
            </Right>
          </>
        )}
      </Form>
    </Card>
  );
}

const schema = object({
  username: yupString.required(),
  password: yupString.required(),
  sellerId: yupString.required(),
});
